<div class="dashboard">
    <!-- Header Principal -->
    <header class="main-header">
        <div class="main-header-left">
            <img class="main-header-logo" [src]="UIDefaultTheme.brand.logo">

            <!-- Skeleton do nome da empresa ao lado da logo -->
            <ng-container *ngIf="loadingContent">
                <div class="d-flex flex-column">
                    <ngx-skeleton-loader [theme]="{
                        width: '320px',
                        height: '14px',
                        margin: '0 0 2px 0'
                      }">
                    </ngx-skeleton-loader>
                    <ngx-skeleton-loader [theme]="{
                        width: '120px',
                        height: '14px',
                        margin: '0'
                      }">
                    </ngx-skeleton-loader>
                </div>
            </ng-container>

            <!-- Informações da conta (switch) -->
            <div class="main-header-account-info" *ngIf="!loadingContent">
                <div class="main-header-account-container"
                    [style.cursor]="canClickAccountName ? 'pointer' : 'default'">
                    <div class="main-header-account-name"
                        (click)="handleAccountNameClick($event)">
                        <span>{{selectedRegisterName}}</span>
                    </div>
                    <span class="main-header-account-role">
                        {{currentRole}}
                    </span>


                </div>
            </div>
        </div>

        <div class="main-header-right">
            <!-- Busca -->
            <form class="search-button-container" [formGroup]="form"
                [class.active]="searchOpen" *ngIf="isMasterOrCommonUser()">

                <button *ngIf="!searchOpen" type="button"
                    class="search-icon-button" (click)="toggleSearch()">
                    <svg-icon src="assets/images/icon-search.svg"></svg-icon>
                </button>

                <div *ngIf="searchOpen" class="search-expanded">
                    <app-search placeholder="Digite" [group]="form"
                        controlName="search" [columns]="columns" [items]="users"
                        [isActive]="searchOpen" [isSearching]="searching"
                        (onClick)="toggleSearch()"
                        (changeValue)="redirectUser($event)"
                        (valueChange)="onSearchInput($event)"
                        (keydown.enter)="handleSearch($event)">
                    </app-search>
                    <button type="button" class="search-close-button"
                        (click)="handleCloseSearching()">
                        <svg-icon src="assets/images/icon-times.svg"></svg-icon>
                    </button>
                </div>
            </form>

            <!-- Usuário -->
            <div class="credentials-container" *ngIf="!loadingContent"
                #toggleOptions (click)="toggleUserOptions($event)">
                <div class="user-profile-avatar">
                    <svg-icon src="assets/images/icon-user.svg"
                        class="user-profile-icon"></svg-icon>
                </div>
                <div class="user-info">
                    <div class="user-greeting">
                        <span>Olá, {{firstName}}</span>
                    </div>
                    <p class="user-email">{{userCredentials.email}}</p>
                </div>
                <svg-icon src="assets/images/icon-carret-down.svg"></svg-icon>

                <div class="credentials-options"
                    [class.active]="userOptionsOpen"
                    (click)="$event.stopPropagation()">
                    <div class="credentials-options-item"
                        (click)="toggleChangeBasicInfoModal(); $event.stopPropagation()">
                        Editar meus dados
                    </div>
                    <div class="credentials-options-item"
                        (click)="toggleChangePasswordModal(); $event.stopPropagation()">
                        Alterar minha senha
                    </div>
                    <div class="credentials-options-item"
                        (click)="logoff(); $event.stopPropagation()">
                        Sair
                    </div>
                </div>
            </div>

            <!-- Skeleton do usuário durante loading -->
            <div *ngIf="loadingContent" class="d-flex align-items-center">
                <ngx-skeleton-loader appearance="circle" [theme]="{
                    width: '32px',
                    height: '32px',
                    margin:'0 16px 0 0'
                  }">
                </ngx-skeleton-loader>
                <div class="d-flex flex-column">
                    <ngx-skeleton-loader [theme]="{
                        width: '110px',
                        height: '14px',
                        margin:'0 0 4px'
                      }"></ngx-skeleton-loader>
                    <ngx-skeleton-loader [theme]="{
                        width: '150px',
                        height: '14px',
                        margin:'0'
                      }"></ngx-skeleton-loader>
                </div>
            </div>

            <!-- Notificações -->
            <div class="content-header-profile-notifications">
                <button class="content-header-profile-button"
                    [class.has-notification]="haveNewNotifications"
                    (click)="toggleNotify()">
                    <svg-icon src="assets/images/icon-bell.svg"
                        class="content-header-profile-icon bell-icon-20"></svg-icon>
                </button>

                <div class="content-header-profile-notifications-sheet"
                    [class.active]="openNotify">
                    <div
                        class="content-header-profile-notifications-sheet-header">
                        <button (click)="markAllAsread()">
                            Marcar todos como lido
                        </button>
                    </div>

                    <div
                        class="content-header-profile-notifications-sheet-body styled-scroll">
                        <div class="content-header-profile-notifications-sheet-notification"
                            *ngFor="let notification of notifications; let i= index"
                            (click)="handleNotifyClick(notification, i)"
                            [class.read]="notification.read">
                            <div
                                class="content-header-profile-notifications-sheet-notification-icon">
                                <svg-icon
                                    src="assets/images/icon-notification.svg"></svg-icon>
                            </div>

                            <div
                                class="content-header-profile-notifications-sheet-notification-content">
                                <span
                                    class="content-header-profile-notifications-sheet-notification-content-title">{{notification.message}}</span>
                                <span
                                    class="content-header-profile-notifications-sheet-notification-content-subtitle"
                                    *ngIf="notification.created_at">{{notification.created_at
                                    | date:'dd/MM/yyyy HH:mm'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <!-- Menu Horizontal -->
    <nav class="horizontal-menu" [class.loading]="loadingMenu">
        <a *ngFor="let item of menu; let i= index" class="horizontal-menu-item"
            [class.active]="getActiveRoute(item.route)"
            (click)="handleMenuClick(item, $event)">
            <span>{{item.title}}</span>
            <span *ngIf="item.route === '/app/dashboard' && pendingCount > 0"
                class="horizontal-menu-badge">
                <app-tooltip [text]="pendingApprovalTooltipText"
                    [position]="'right'">
                    {{pendingCount > 100 ? '99+' : pendingCount}}
                </app-tooltip>
            </span>
        </a>
    </nav>

    <!-- Conteúdo Principal -->
    <div class="content">
        <div class="gray-box" [class.active]="searchOpen"
            (click)="handleCloseSearching()">
            <div class="content-body">
                <app-container [noBg]="true" [fullWidth]="isApprovalRoute">
                    <app-breadcrumb></app-breadcrumb>
                    <router-outlet></router-outlet>
                </app-container>
            </div>
        </div>
    </div>
</div>

<!-- <app-side-modal [active]="roleModal" title="Adicionar papel"
    (onClose)="toggleRoleModal()">
    <form [formGroup]="roleForm">
        <h3 class="title">Papéis atuais</h3>
        <p class="sub-title">{{renderRoles()}}</p>
        <hr>

        <div class="row">
            <div class="col-12">
                <app-select [items]="filteredRoleOptions" [multiple]="true"
                    [group]="roleForm" controlName="role"
                    placeholder="Selecione" label="Papel">
                </app-select>
                <app-spacer [bottom]="32"></app-spacer>
            </div>
        </div>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="toggleRoleModal()" [phantom]="true">
                    Cancelar
                </app-button>
            </div>

            <div class="col-12 col-lg-6">
                <div class="text-right">
                    <app-button (onClick)="addAgentRole()"
                        [disabled]="roleForm.invalid" class="add-button"
                        [loading]="sendingRequest">
                        Adicionar
                    </app-button>
                </div>
            </div>
        </div>
    </form>
</app-side-modal> -->

<app-side-modal [active]="newUserModal" title="Novo cadastro"
    (onClose)="toggleNewUserModal()">
    <form [formGroup]="newUserForm">
        <div class="row">
            <div class="col-12">
                <app-select [items]="primaryRoleOptions" [group]="newUserForm"
                    controlName="role" placeholder="Selecione" label="Papel">
                </app-select>
                <app-spacer [bottom]="32"></app-spacer>
            </div>

            <ng-container *ngIf="newUserForm.controls.role.value">
                <div class="col-12" *ngIf="selectedApplicable === 'provider'">
                    <app-select [items]="roleOptions" [group]="newUserForm"
                        controlName="agent" [multiple]="true"
                        placeholder="Selecione" label="Agente">
                    </app-select>
                    <app-spacer [bottom]="32"></app-spacer>
                </div>

                <div class="col-12">
                    <app-select [items]="fundOptions" [group]="newUserForm"
                        controlName="interest_fund" placeholder="Selecione"
                        label="Fundo de interesse">
                    </app-select>
                    <app-spacer [bottom]="32"></app-spacer>
                </div>
            </ng-container>
        </div>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="toggleNewUserModal()" [phantom]="true">
                    Cancelar
                </app-button>
            </div>

            <div class="col-12 col-lg-6">
                <div class="text-right">
                    <app-button (onClick)="registerNewUser()"
                        [disabled]="newUserForm.invalid" class="add-button"
                        [loading]="sendingRequest">
                        Cadastrar
                    </app-button>
                </div>
            </div>
        </div>
    </form>
</app-side-modal>

<app-side-modal [active]="roleSelectionModal"
    title="Selecionar papel para edição" (onClose)="toggleRoleSelectionModal()">
    <div *ngIf="selectedUserForRoleSelection">
        <div class="mb-4">
            <h5 class="role-selection-modal__name">
                {{selectedUserForRoleSelection.name}}</h5>
            <p class="role-selection-modal__document">
                {{selectedUserForRoleSelection.document}}</p>
            <p>Selecione o papel abaixo para ser redirecionado à edição:</p>
        </div>

        <div class="row">
            <div class="col-12 mb-3"
                *ngFor="let role of selectedUserForRoleSelection.roles">
                <ng-container *ngIf="role.applicable !== 'representative'">
                    <div class="card p-3 cursor-pointer hover-shadow role-selection-modal__card"
                        (click)="selectRoleForEdit(role)">
                        <div
                            class="d-flex align-items-center justify-content-between">
                            <span
                                style="font-weight: 600;">{{role.applicable_display}}</span>
                            <svg-icon src="assets/images/icon-right.svg"
                                class="text-muted"></svg-icon>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-12">
                <app-button (onClick)="toggleRoleSelectionModal()"
                    [phantom]="true" [fullWidth]="true">
                    Cancelar
                </app-button>
            </div>
        </div>
    </div>
</app-side-modal>

<app-user-settings-modal (onClose)="toggleChangePasswordModal()"
    [active]="changePasswordShow" title="Alterar minha senha"
    [confirmLabel]="changePasswordStep === 0 ? 'Validar senha' : 'Alterar senha'"
    [isDisabled]="handleDisable()" [isLoading]="passwordSubmiting"
    (onSubmit)="handleSendPassword()"
    figure="assets/images/figure-change-password.svg">
    <form [formGroup]="newUserForm">
        <ng-container *ngIf="changePasswordStep === 0">
            <app-input [group]="changePasswordForm"
                controlName="current_password" type="password"
                label="Infome a senha atual">
            </app-input>
        </ng-container>

        <ng-container *ngIf="changePasswordStep === 1">
            <div class="row">
                <div class="col-12">
                    <app-radio [readOnly]="true"
                        [isChecked]="passwordStrength().includes(1)">Mínimo
                        de 8 caracteres
                    </app-radio>
                    <app-spacer [bottom]="14"></app-spacer>
                </div>
                <div class="col-12">
                    <app-radio [readOnly]="true"
                        [isChecked]="passwordStrength().includes(2)">Mínimo
                        de 1 número
                    </app-radio>
                    <app-spacer [bottom]="14"></app-spacer>
                </div>
                <div class="col-12">
                    <app-radio [readOnly]="true"
                        [isChecked]="passwordStrength().includes(3)">Letras
                        maiúsculas e
                        minúsculas</app-radio>
                    <app-spacer [bottom]="14"></app-spacer>
                </div>
                <div class="col-12">
                    <app-radio [readOnly]="true"
                        [isChecked]="passwordStrength().includes(4)">Caracteres
                        especiais
                    </app-radio>
                    <app-spacer [bottom]="21"></app-spacer>
                </div>

                <div class="col-12">
                    <p class="user-settings-modal-description-text">Para
                        reforçar a
                        segurança da sua senha, não utilize
                        informações
                        pessoais como datas de nascimentos ou números de
                        telefones e nem números sequenciais.</p>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
                <div class="col-12">
                    <app-input type="password"
                        label="Defina uma senha de acesso"
                        [group]="changePasswordForm" controlName="password">
                    </app-input>
                    <div class="user-settings-modal-password-meter">
                        <p class="user-settings-modal-password-meter-text">
                            {{passwordStrengthText()}}</p>

                        <div class="user-settings-modal-password-meter-bars"
                            [class.strong]="passwordStrengthPercentage() > 90">
                            <div class="user-settings-modal-password-meter-bar"
                                [class.weak]="passwordStrengthPercentage() > 30"
                                [class.middle]="passwordStrengthPercentage() > 60">
                            </div>
                            <div class="user-settings-modal-password-meter-bar"
                                [class.middle]="passwordStrengthPercentage() > 60">
                            </div>
                            <div class="user-settings-modal-password-meter-bar">
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
                <div class="col-12">
                    <app-input type="password" label="Confirme sua senha"
                        [group]="changePasswordForm"
                        controlName="confirm_password">
                    </app-input>

                    <!-- Exibe erro se as senhas não coincidirem -->
                    <div *ngIf="showPasswordMismatchError()"
                        class="error-message role-selection-modal__password-error">
                        As senhas não coincidem
                    </div>

                    <!-- Exibe mensagem de sucesso quando as senhas coincidem -->
                    <div *ngIf="passwordsMatch()" class="success-message role-selection-modal__password-success">
                        ✓ As senhas coincidem
                    </div>
                </div>
            </div>
        </ng-container>
    </form>
</app-user-settings-modal>

<app-user-settings-modal (onClose)="toggleChangeBasicInfoModal()"
    [active]="changeBasicInfoShow" title="Editar meus dados"
    confirmLabel="Salvar alterações" [isDisabled]="handleBasicInfoDisable()"
    [isLoading]="basicInfoSubmiting" (onSubmit)="changeBasicInfo()"
    figure="assets/images/ilustra_perfil_Prancheta.svg">
    <form [formGroup]="changeBasicInfoForm">
        <div class="row">
            <div class="col-12 col-md-6 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    País de origem
                </span>

                <span class="dash-details-card-item-title">
                    {{userNacionality}}
                </span>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-md-6 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    cpf
                </span>

                <span class="dash-details-card-item-title">
                    {{userDocument}}
                </span>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12">
                <app-input label="Nome completo" [group]="changeBasicInfoForm"
                    controlName="full_name"
                    helpText="Sem abreviações, como está em seus documentos"
                    [maxLength]="60">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12">
                <app-input label="Seu melhor e-mail"
                    [group]="changeBasicInfoForm" controlName="email">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>


        </div>
    </form>
</app-user-settings-modal>

<!-- <app-report-chat></app-report-chat> -->

<div class="pending-confirmation-modal-wrap"
    [class.pending-confirmation-modal-wrap--active]="showPendingConfirmationModal">
    <app-carbon-warning-modal [active]="showPendingConfirmationModal"
        title="Fundos pendentes de confirmação"
        [customContent]="true"
        [contentOverflowVisible]="true"
        confirmText="Entendi"
        cancelText=""
        [confirmAction]="dismissPendingConfirmationModal.bind(this)"
        [cancelAction]="dismissPendingConfirmationModal.bind(this)"
        (onClose)="dismissPendingConfirmationModal()">
        <div class="pending-confirmation-modal">
            <p>
                Existem fundos com transferência aguardando confirmação.
                Confirme a inativação quando estiver pronto.
            </p>
            <p>
                Se quiser ver essa lista novamente, filtre os fundos pela opção
                <strong>Transferência a confirmar</strong>.
            </p>
            <div class="pending-confirmation-modal-table-wrap"
                *ngIf="pendingConfirmationFunds.length > 0">
                <table class="pending-confirmation-modal-table">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>CNPJ</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let fund of pendingConfirmationFunds">
                            <td>{{ fund.name }}</td>
                            <td>{{ fund.cnpj }}</td>
                            <td class="pending-confirmation-modal-actions">
                                <app-tooltip text="Visualizar"
                                    position="left" [zIndex]="20">
                                    <button type="button"
                                        class="dash-item-button"
                                        (click)="viewPendingConfirmationFund(fund, $event)">
                                        <svg-icon
                                            src="assets/images/icon-eye.svg"></svg-icon>
                                    </button>
                                </app-tooltip>
                                <app-tooltip text="Confirmar inativação"
                                    position="left" [zIndex]="20">
                                    <button type="button"
                                        class="dash-item-button"
                                        (click)="openPendingConfirmInactivation(fund, $event)">
                                        <svg-icon
                                            src="assets/images/icon-check.svg"></svg-icon>
                                    </button>
                                </app-tooltip>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </app-carbon-warning-modal>
</div>

<div class="pending-confirm-inactivation-modal">
    <app-carbon-warning-modal [active]="showPendingConfirmInactivationModal"
        title="Atenção"
        message="Esta ação <strong>não poderá ser desfeita</strong>. O fundo será <strong>inativado imediatamente</strong>, junto com os cedentes e cotistas vinculados."
        confirmText="Confirmar inativação" cancelText="Cancelar"
        [loading]="pendingConfirmLoading"
        loadingText="Inativando fundo..."
        loadingConfirmText="Inativando..."
        [skipAutoCloseOnConfirm]="true"
        [confirmAction]="confirmPendingInactivation.bind(this)"
        [cancelAction]="closePendingConfirmInactivation.bind(this)"
        (onClose)="closePendingConfirmInactivation()">
    </app-carbon-warning-modal>
</div>